import React from 'react';
import PropTypes from 'prop-types';
import ScrollBar from 'components_v2/common/ScrollBar';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import makeRequest from 'utils/makeRequest';
// import Cookie from 'utils/cookies';
// import Image from 'components/Image';
import Link from 'components/Link';
import classNames from 'classnames';
import { wait, inViewForReact, cityNameMapreverse } from 'utils/common';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import AdCaller from 'helpers/ads/adCaller';
import s from './SubsectionList.scss';
import PopupPortal from '../PopupPortal';
import SponserAdSlot from '../../../routes/home/components/common/SponserAdSlot';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

// import { ZEB_PAY_URL } from '../../../constants';

class SubsectionList extends React.Component {
  constructor() {
    super();
    this.state = {
      items: [],
      filteredItems: [],
      selectedIndex: 0,
      l2selected: false,
      activeSearchString: '',
      selectedL1Index: 0,
      clientSide: false,
      updateScroll: true,
    };

    this.sectionIdToUserPrefMap = {
      entertainmentnews: 'geoLang',
      citizenReporter: 'geoCity',
      tv: 'geoLang',
      citynews: 'geoCity',
    };

    this.listRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ clientSide: true }, () => {
      const { data } = this.props;
      if (!(data && !Array.isArray(data) && data.dataUrl)) {
        this.checkUserPref();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const dataContext = this.context;
    if (
      dataContext &&
      this.userPrefKey &&
      dataContext[this.userPrefKey] !== this.currentPrefVal
    ) {
      this.currentPrefVal = dataContext[this.userPrefKey];
      // Do not make calls if the current section is clicked
      if (this.props.sectionId !== dataContext.sectionId) {
        this.checkUserPref();
      }
    }

    const { geoCityData: { state: prevGeoState = '' } } = prevProps;

    const { itemNameSelected, filteredItems, selectedIndex } = this.state;
    const {
      setActiveTab = () => {},
      sectionId,
      geoCityData: { state },
    } = this.props;

    if (
      sectionId === 'elections' &&
      (((prevGeoState || state) &&
        prevGeoState !== state &&
        filteredItems &&
        filteredItems.length > 0) ||
        ((!prevState.filteredItems || prevState.filteredItems.length === 0) &&
          state &&
          filteredItems &&
          filteredItems.length > 0))
    ) {
      this.loadDataForState();
    }

    if (prevState.itemNameSelected !== this.state.itemNameSelected) {
      setActiveTab(itemNameSelected);
    } else if (
      (filteredItems || prevState.filteredItems) &&
      selectedIndex >= 0 &&
      prevState.filteredItems !== filteredItems &&
      filteredItems.length > selectedIndex &&
      filteredItems[selectedIndex] &&
      filteredItems[selectedIndex].name
    ) {
      setActiveTab(filteredItems[selectedIndex].name);
    }
  }

  loadDataForState = () => {
    const { filteredItems, selectedL1Index } = this.state;
    const { geoCityData: { state = '' }, cardDefaultTab = '' } = this.props;
    const filteredStateIndex = filteredItems.findIndex(
      tab => tab.name && tab.name.toLowerCase() === state.toLowerCase(),
    );

    if (filteredStateIndex !== selectedL1Index && filteredStateIndex >= 0) {
      const filteredHeaderTab = filteredItems[filteredStateIndex];
      const { onChangeCallback = () => {} } = this.props;
      if (filteredHeaderTab?.headerHeading) {
        onChangeCallback(
          filteredHeaderTab.dataUrl,
          true,
          filteredHeaderTab.moreText,
          filteredHeaderTab.path,
          filteredHeaderTab.loadMoreDataUrl,
          filteredHeaderTab?.headerHeading,
        );
      } else {
        onChangeCallback(
          filteredHeaderTab.dataUrl,
          true,
          filteredHeaderTab.moreText,
          filteredHeaderTab.path,
          filteredHeaderTab.loadMoreDataUrl,
        );
      }
      this.setState(
        {
          selectedL1Index: filteredStateIndex,
          l2selected: false,
          itemNameSelected: filteredHeaderTab.name,
        },
        this.setFocusToSelectedElement,
      );
    } else if (
      (!filteredStateIndex || filteredStateIndex < 0) &&
      cardDefaultTab
    ) {
      this.loadDataForItemName(cardDefaultTab);
    }
  };

  loadDataForItemName = itemName => {
    const { filteredItems, selectedL1Index } = this.state;

    const filteredItemsIndex = filteredItems.findIndex(
      tab => tab.name.toLowerCase() === itemName.toLowerCase(),
    );
    if (filteredItemsIndex !== selectedL1Index && filteredItemsIndex >= 0) {
      const filteredHeaderTab = filteredItems[filteredItemsIndex];
      const { onChangeCallback = () => {} } = this.props;
      if (filteredHeaderTab?.headerHeading) {
        onChangeCallback(
          filteredHeaderTab.dataUrl,
          true,
          filteredHeaderTab.moreText,
          filteredHeaderTab.path,
          filteredHeaderTab.loadMoreDataUrl,
          filteredHeaderTab?.headerHeading,
        );
      } else {
        onChangeCallback(
          filteredHeaderTab.dataUrl,
          true,
          filteredHeaderTab.moreText,
          filteredHeaderTab.path,
          filteredHeaderTab.loadMoreDataUrl,
        );
      }

      this.setState(
        {
          selectedL1Index: filteredItemsIndex,
          l2selected: false,
          itemNameSelected: filteredHeaderTab.name,
        },
        this.setFocusToSelectedElement,
      );
    }
  };

  checkUserPref() {
    const { sectionId } = this.props;
    if (!sectionId) {
      return;
    }

    const userPrefKey = this.sectionIdToUserPrefMap[sectionId];
    if (userPrefKey) {
      this.userPrefKey = userPrefKey;
      this.isCityGeo = userPrefKey === 'geoCity';
      this.updateDataAsPerUserPref(userPrefKey);
    }
  }

  /*componentDidUpdate(prevProps, prevState) {
    if (prevState.clientSide === false && this.state.clientSide === true) {
      const dataContext = this.context;
      console.log('context', dataContext);
      // if (dataContext && dataContext.geoCity) {
      // }
    }
  }*/

  updateDataAsPerUserPref = userPrefKey => {
    if (!this.state.clientSide) {
      return;
    }
    const dataContext = this.context;
    // console.log('context', dataContext);
    if (dataContext && dataContext[userPrefKey]) {
      this.userPrefKey = userPrefKey;
      this.currentPrefVal = dataContext[userPrefKey];
      const { data } = this.props;
      const { items } = this.state;
      let item = {};
      const itemsList = Array.isArray(data) ? data : items;
      const itemsPresent = Array.isArray(itemsList) && itemsList.length > 0;
      if (!itemsPresent) {
        return;
      }
      const { tabCount } = data;
      let selectedIndex = -1;
      if (itemsList && itemsList.length > 0) {
        for (let i = 0; i < itemsList.length; i += 1) {
          item = itemsList[i];
          if (
            item.name &&
            item.name.toLowerCase() === dataContext[userPrefKey].toLowerCase()
          ) {
            selectedIndex = i;
            break;
          }
        }

        if (selectedIndex >= 0) {
          const { onChangeCallback = () => {} } = this.props;
          if (item?.headerHeading) {
            onChangeCallback(
              item.dataUrl,
              true,
              item.moreText,
              item.path,
              item?.headerHeading,
            );
          } else {
            onChangeCallback(item.dataUrl, true, item.moreText, item.path);
          }

          this.setState(
            {
              selectedIndex,
              selectedL1Index: selectedIndex,
              l2selected: selectedIndex >= tabCount,
              itemNameSelected: item.name,
            },
            this.setFocusToSelectedElement,
          );
        }
      }
    }
  };

  setGeolocationCity = city => {
    if (
      this.isCityGeo &&
      city &&
      city.toLowerCase() !== 'featured' &&
      this.context &&
      typeof this.context.setLanguageVal === 'function'
    ) {
      this.context.setLanguageVal(city, true, this.props.sectionId);
      // let domain = 'indiatimes.com';
      // if (document.domain.indexOf('timesofindia.com') >= 0) {
      //   domain = 'timesofindia.com';
      // }
      // Cookie.set('geolocation', city, 365, '/', domain);
    }
  };

  loadNavigation() {
    const { data, isMobile } = this.props;
    const dataUrl = data && !Array.isArray(data) && data.dataUrl;
    if (!dataUrl) {
      return;
    }

    makeRequest.get(dataUrl, { isMobile }, 'skipfeedengine').then(result => {
      if (
        result &&
        result.data &&
        result.data.items &&
        result.data.items.length > 0
      ) {
        this.setState(
          {
            items: result.data.items,
            filteredItems: result.data.items,
          },
          () => {
            this.checkUserPref();
          },
        );
      }
    });
  }

  getGaObject(subLabel, isFifa = false) {
    const { gaData } = this.props;
    if (gaData && gaData.gaAction && gaData.partialGaLabel) {
      if (isFifa) {
        return {
          data: {
            gaAction: gaData.gaAction,
            gaLabel: `${subLabel}`,
            gaCategory: 'fifa_2022_widget',
          },
        };
      }
      return {
        data: {
          gaAction: gaData.gaAction,
          gaLabel: `${gaData.partialGaLabel}${subLabel}`,
        },
      };
    }
    return {};
  }
  openListingDropDown = async () => {
    this.setState({ opened: true });
    await wait(10);
    this.setState({ mounted: true });
    document.body.classList.add(s.body_OH);
    const { linkData } = this.props;
    if (linkData && linkData.gaAction) {
      sendGaThroughProps({
        data: {
          gaAction: linkData.gaAction,
          gaLabel: 'Click-SearchDots',
        },
      });
    }
  };

  closeListingDropdown = async () => {
    this.setState({ mounted: false });
    await wait(500);
    document.body.classList.remove(s.body_OH);
    this.setState({ opened: false, activeSearchString: '' });
    this.filterResults('');
    // sendGaThroughProps(this.getGaObject('-Close'));
  };
  filterDropDownItem = event => {
    const activeSearchString = event.target.value.toLowerCase() || '';
    this.filterResults(activeSearchString);
  };
  filterResults = activeSearchString => {
    const { items } = this.state;
    const { data } = this.props;
    let filteredItems = Array.isArray(data) ? data : items;
    // let filteredItems = data || items || [];
    if (activeSearchString && filteredItems && filteredItems.length > 0) {
      const strLen = activeSearchString.length;
      filteredItems = [];
      let counter = 0;
      for (; counter < items.length; counter += 1) {
        if (
          items[counter].name.length >= strLen &&
          items[counter].name.toLowerCase().substring(0, strLen) ===
            activeSearchString
        ) {
          filteredItems.push({ ...items[counter], itemIndex: counter });
        }
      }
    }

    this.setState({
      filteredItems,
      activeSearchString,
      updateScroll: !this.state.updateScroll,
    });
  };
  toggleLoader(loading) {
    if (typeof this.props.toggleLoader === 'function') {
      this.props.toggleLoader(loading);
    }
  }
  handleClick = (e, item, index) => {
    e.stopPropagation();
    const { onChangeCallback = () => {} } = this.props;
    if (item?.headerHeading) {
      onChangeCallback(
        item.dataUrl,
        true,
        item.moreText,
        item.path,
        item?.headerHeading,
      );
    } else {
      onChangeCallback(item.dataUrl, true, item.moreText, item.path);
    }

    this.closeListingDropdown();
    // this.toggleLoader(true);
    if (item?.headerHeading) {
      sendGaThroughProps(this.getGaObject(`${item.name}`, true));
    } else {
      sendGaThroughProps(this.getGaObject(`_${item.name}`));
    }

    this.setState(
      {
        selectedIndex:
          typeof item.itemIndex !== 'undefined' ? item.itemIndex : index,
        l2selected: true,
        itemNameSelected: item.name,
      },
      this.setFocusToSelectedElement,
    );
    this.setGeolocationCity(
      cityNameMapreverse[item.name.toLowerCase()] || item.name,
    );
  };

  setFocusToSelectedElement = () => {
    setTimeout(() => {
      if (this.listRef && this.listRef.current) {
        const selectedElem = this.listRef.current.getElementsByClassName(
          `${s.selected}`,
        );

        if (
          selectedElem &&
          selectedElem[0] &&
          this.prevSelectedVal !== selectedElem[0].innerText &&
          !inViewForReact(selectedElem[0])
        ) {
          const elem = selectedElem[0];
          this.prevSelectedVal = elem.innerText;
          const elemBoundary = elem.getBoundingClientRect();
          const elemEndPos = elemBoundary.left + elemBoundary.width;
          const windowWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          if (elemEndPos > windowWidth) {
            this.listRef.current.scrollLeft += elemEndPos - windowWidth;
          } else if (elemBoundary.left < 0) {
            this.listRef.current.scrollLeft += elemBoundary.left;
          }
        }
      }
    }, 0);
  };

  static getActiveDropDown(data) {
    let dropdown =
      data && typeof data.filter === 'function'
        ? data.filter(item => item.active)[0]
        : {};

    if (
      (!dropdown || !dropdown.name) &&
      Array.isArray(data) &&
      data.length > 0
    ) {
      dropdown = data[0];
    }

    return dropdown;
  }

  updateListData = (e, item, index, selected) => {
    e.stopPropagation();
    const { onChangeCallback = () => {}, ga4Type, ga4Category } = this.props;
    if (!selected) {
      let selectedIndex = index;
      if (this.state.l2selected && index > 1) {
        selectedIndex -= 1;
      }
      if (item?.headerHeading) {
        onChangeCallback(
          item.dataUrl,
          true,
          item.moreText,
          item.path,
          item.loadMoreDataUrl,
          item.name,
          item?.headerHeading,
        );
      } else {
        onChangeCallback(
          item.dataUrl,
          true,
          item.moreText,
          item.path,
          item.loadMoreDataUrl,
          item.name,
        );
      }

      this.setState({
        selectedL1Index: selectedIndex,
        l2selected: false,
        itemNameSelected: item.name,
      });
      this.setGeolocationCity(item.name);
      if (item?.headerHeading) {
        sendGaThroughProps(this.getGaObject(`${item.name}`, true));
      } else {
        sendGaThroughProps(this.getGaObject(`_${item.name}`));
      }
    }
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        label: `${item?.name}`,
        category: `${'tab_change' || ga4Category}`,
      });
    }
  };

  render() {
    //const closeDropDown = this.props.closeThisDropDown;
    const {
      dropdownTitle = 'Category',
      isWhiteTheme,
      // sectionId,
      size,
      linkData,
      overrideClass,
      data,
      subHeading,
      poweredByHtml,
      sponsoredData,
      datads,
      ga4Type,
      ga4Category,
      sponsoredAd,
    } = this.props;
    const {
      items,
      filteredItems,
      l2selected,
      selectedIndex,
      itemNameSelected,
    } = this.state;
    let { selectedL1Index } = this.state;
    const itemsList = Array.isArray(data) ? data : items;
    const itemsPresent = Array.isArray(itemsList) && itemsList.length > 0;
    let showDropdown = true;
    let l1List = [];
    if (itemsPresent) {
      const { tabCount } = data;
      let l1Len = 0;
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(tabCount)) {
        l1Len = parseInt(tabCount, 10);
      }
      const itemsInL1 = Math.min(l1Len, itemsList.length);
      l1List = itemsList.slice(0, itemsInL1);
      if (
        l1List.length > 0 &&
        selectedIndex > l1List.length - 1 &&
        l2selected
      ) {
        l1List.splice(1, 0, itemsList[selectedIndex]);
        selectedL1Index = 1;
        l1List = l1List.slice(0, itemsInL1);
      } else if (l2selected) {
        selectedL1Index = selectedIndex;
      }

      showDropdown = l1List.length < itemsList.length;
    }

    const listingClassName = classNames({
      [s.header]: true,
      [s.themewhite]: isWhiteTheme,
      [s[size]]: size,
      [`${overrideClass}`]: overrideClass,
      [s.powerby]: overrideClass === 'powerby',
      [s.powerby_active]: poweredByHtml !== '',
    });

    // const filteredData = data;
    const containerClassName = classNames({
      [s.my_dropdown]: true,
      [s.listing]: this.state.mounted,
    });

    const showSearch = this.props.showSearchBox && itemsList.length > 10;
    const sponsoredTxt =
      sponsoredData && sponsoredData.sponsoredTxt
        ? sponsoredData.sponsoredTxt
        : '';
    const sponsoredLink =
      sponsoredData && sponsoredData.sponsoredLink
        ? sponsoredData.sponsoredLink
        : '';
    const sponsoredLogomsid =
      sponsoredData && sponsoredData.sponsoredLogomsid
        ? sponsoredData.sponsoredLogomsid
        : '';
    const sponsoredClass =
      sponsoredData && sponsoredData.sponsoredClass
        ? sponsoredData.sponsoredClass
        : '';

    let sponsoredDataHTML = '';
    const sponserAdWithTitle = sponsoredAd?.withtitle;
    if (sponsoredLink && sponsoredLogomsid) {
      sponsoredDataHTML = (
        <div className={s[sponsoredClass]}>
          <Link to={sponsoredLink} doNotChangeURL target="_blank">
            <img
              src={`https://static.toiimg.com/photo/msid-${sponsoredLogomsid}.cms`}
              alt="Sponsored by"
            />
          </Link>
        </div>
      );
    } else if (sponsoredTxt && sponsoredLogomsid) {
      sponsoredDataHTML = (
        <div className={s[sponsoredClass]}>
          {sponsoredTxt}
          <img
            src={`https://static.toiimg.com/photo/msid-${sponsoredLogomsid}.cms`}
            alt={sponsoredTxt}
          />
        </div>
      );
    } else if (sponserAdWithTitle) {
      sponsoredDataHTML = (
        <div className={s[sponsoredClass]}>
          {sponsoredTxt && <div>{sponsoredTxt}</div>}
          <AdCaller data={sponsoredAd} immediateLoad />
        </div>
      );
    }
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadNavigation();
        }}
        viewMargin="500px 0px 500px 0px"
      >
        <div className={s.subsection}>
          {this.props.hideHeading ? null : (
            <div className={`${listingClassName}`}>
              {this.props.headingLink ? (
                <h2 className={`${s.heading}`}>
                  <Link
                    className={`${s.linkarrow}`}
                    to={this.props.headingLink}
                    data={linkData}
                    data-newga={this.props.newga}
                    doNotChangeURL={this.props.doNotChangeURL}
                    ga4Data={
                      ga4Type && [
                        {
                          event: 'user_click',
                          type: `${ga4Type}`,
                          label: `${this.props.headingname.toLowerCase()}`,
                          category: `${'section_heading_click' || ga4Category}`,
                        },
                      ]
                    }
                  >
                    {this.props.headingname}
                  </Link>
                  {subHeading && (
                    <span className={s.sponsered}>({subHeading})</span>
                  )}
                </h2>
              ) : (
                <h2 className={s.heading}>{this.props.headingname}</h2>
              )}
              {poweredByHtml && (
                <div
                  className={s.poweredby}
                  dangerouslySetInnerHTML={{
                    __html: poweredByHtml,
                  }}
                />
              )}
              {sponsoredDataHTML}
              {itemsPresent &&
                showDropdown && (
                  <div className={s.change} onClick={this.openListingDropDown}>
                    <span>
                      <i />
                      <i />
                      <i />
                    </span>
                    {this.state.showDropDown && this.OpenDropdown()}
                  </div>
                )}
            </div>
          )}
          {!sponserAdWithTitle && (
            <SponserAdSlot
              data={datads}
              isPrime={this.props.isPrime}
              isWapView
            />
          )}
          {l1List &&
            l1List.length > 0 && (
              <ul className={s.SubNav} ref={this.listRef}>
                {l1List.map((item, index) => (
                  <li
                    key={index}
                    className={`${index === selectedL1Index ? s.selected : ''}`}
                    onClick={e =>
                      this.updateListData(
                        e,
                        item,
                        index,
                        index === selectedL1Index,
                      )
                    }
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
        </div>

        {this.state.opened &&
          showDropdown && (
            <PopupPortal usePopupPortal={this.props.usePopupPortal}>
              <div className={containerClassName}>
                <span
                  className={s.backbg}
                  onClick={this.closeListingDropdown}
                />
                <div
                  className={`${s.outer} ${!showSearch ? s.scrollNone : ''}`}
                >
                  {!showSearch && (
                    <span className={s.dropdown_heading}>
                      tap to change {dropdownTitle}
                    </span>
                  )}

                  {showSearch && (
                    <div className={s.searchBox}>
                      <input
                        type="text"
                        placeholder={`Search your ${dropdownTitle}`}
                        onChange={this.filterDropDownItem}
                        value={this.state.activeSearchString}
                      />
                    </div>
                  )}
                  <ScrollBar
                    tagElement="ul"
                    className={s.optionsList}
                    updateScroll={this.state.updateScroll}
                  >
                    {filteredItems &&
                      filteredItems.length > 0 &&
                      filteredItems.map((item, index) => (
                        <li
                          className={
                            itemNameSelected === item.name ||
                            (!itemNameSelected &&
                              itemsList &&
                              itemsList[0].name === item.name)
                              ? [s.active]
                              : ''
                          }
                          key={item.name}
                          onClick={
                            item.active
                              ? undefined
                              : e => this.handleClick(e, item, index)
                          }
                        >
                          {item.name}
                        </li>
                      ))}
                    {!filteredItems ||
                      (filteredItems.length === 0 && <li>No Matches Found</li>)}
                  </ScrollBar>
                </div>
              </div>
            </PopupPortal>
          )}
      </InViewObserver>
    );
  }
}
SubsectionList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  datads: PropTypes.arrayOf(PropTypes.shape({})),
  onChangeCallback: PropTypes.func,
  showSearchBox: PropTypes.bool,
  dropdownTitle: PropTypes.string,
  isWhiteTheme: PropTypes.bool,
  sectionId: PropTypes.string,
  gaData: PropTypes.shape({}),
  toggleLoader: PropTypes.func,
  headingname: PropTypes.string,
  headingLink: PropTypes.string,
  size: PropTypes.string,
  linkData: PropTypes.shape({}),
  sponsoredData: PropTypes.shape({
    sponsoredTxt: PropTypes.string,
    sponsoredLink: PropTypes.string,
    sponsoredLogomsid: PropTypes.string,
    sponsoredClass: PropTypes.string,
  }),
  newga: PropTypes.string,
  overrideClass: PropTypes.string,
  subHeading: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  usePopupPortal: PropTypes.bool,
  poweredByHtml: PropTypes.node,
  setActiveTab: PropTypes.func,
  geoCityData: PropTypes.shape({
    state: PropTypes.string,
  }),
  cardDefaultTab: PropTypes.string,
  isMobile: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
SubsectionList.defaultProps = {
  data: undefined,
  datads: undefined,
  showSearchBox: false,
  dropdownTitle: undefined,
  isWhiteTheme: false,
  gaData: undefined,
  toggleLoader: undefined,
  sectionId: undefined,
  onChangeCallback: undefined,
  headingname: undefined,
  sponsoredData: undefined,
  headingLink: '',
  size: '',
  linkData: undefined,
  newga: '',
  overrideClass: '',
  subHeading: '',
  doNotChangeURL: false,
  usePopupPortal: false,
  poweredByHtml: '',
  setActiveTab: () => {},
  geoCityData: {},
  cardDefaultTab: undefined,
  isMobile: false,
  ga4Type: '',
  ga4Category: '',
};

SubsectionList.contextType = UserPreferenceContext;

export default SubsectionList;
